import { useMemo } from "react";
import { useLocation } from "react-router";

const useCasinoType = () => {
  const location = useLocation();
  const { pathname } = location;

  const findCasinoOrLiveCasino = useMemo(() => {
    const pathArray = pathname.split("/");
    if (pathArray.find((item) => item === "casino")) {
      return "casino";
    } else if (pathArray.find((item) => item === "live-casino")) {
      return "live-casino";
    } else if (pathArray.find((item) => item === "sports")) {
      return "sports";
    } else if (pathArray.find((item) => item === "lottery")) {
      return "lottery";
    } else if (pathArray.find((item) => item === "promotion")) {
      return "promotion";
    } else if (pathArray.find((item) => item === "terms")) {
      return "terms";
    }
  }, [pathname]);

  return findCasinoOrLiveCasino;
};

export default useCasinoType;
